// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import LanguageSwitcher from './LanguageSwitcher';
import Footer from './Footer';
import { MailIcon, PhoneIcon, InstagramIcon, FacebookIcon } from './Icons';
import './Layout.css';

export default function Layout() {
  return (
    <div className="layout">
      {/* Barre du haut : email, téléphone et réseaux sociaux, alignés à
          droite avec un espacement uniforme (comme sur le site Gramen) */}
      <header>
        <div className="top-bar">
          <span className="top-bar-item">
            <MailIcon />
            diasporabakong@gmail.com
          </span>
          <span className="top-bar-item">
            <PhoneIcon />
            +1 437-860-3973
          </span>
          <a
            className="top-bar-item top-bar-social"
            href="https://www.instagram.com/diasporabakong/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramIcon />
          </a>
          <a
            className="top-bar-item top-bar-social"
            href="https://www.facebook.com/groups/28300444646228501"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FacebookIcon />
          </a>
        </div>
        {/* Barre de navigation */}
        <NavigationBar />
      </header>

      {/* Contenu principal */}
      <main className="main-content">
        <Outlet />
      </main>

      {/* Pied de page (toutes les pages, via Layout) */}
      <Footer />

      {/* Sélecteur de langue flottant (toutes les pages) */}
      <LanguageSwitcher />
    </div>
  );
}
